import type { IconProps } from './../../models/icon';

export function SafeIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M14.5713 13.7142C16.2281 13.7142 17.5713 12.3711 17.5713 10.7142C17.5713 9.05738 16.2281 7.71423 14.5713 7.71423C12.9144 7.71423 11.5713 9.05738 11.5713 10.7142C11.5713 12.3711 12.9144 13.7142 14.5713 13.7142Z"
        />
        <path
          fill={secondaryColor}
          fillRule="evenodd"
          d="M2.57122 0.857178H21.4284C22.3752 0.857178 23.1426 1.62469 23.1426 2.57146V18.8572C23.1426 19.804 22.3752 20.5715 21.4284 20.5715H2.57122C1.62445 20.5715 0.856934 19.804 0.856934 18.8572V2.57146C0.856934 1.62469 1.62445 0.857178 2.57122 0.857178ZM17.5712 10.7143C17.5712 12.3712 16.2281 13.7143 14.5712 13.7143C12.9144 13.7143 11.5712 12.3712 11.5712 10.7143C11.5712 9.05746 12.9144 7.71432 14.5712 7.71432C16.2281 7.71432 17.5712 9.05746 17.5712 10.7143Z"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M14.5713 13.7142C16.2281 13.7142 17.5713 12.3711 17.5713 10.7142C17.5713 9.05738 16.2281 7.71423 14.5713 7.71423C12.9144 7.71423 11.5713 9.05738 11.5713 10.7142C11.5713 12.3711 12.9144 13.7142 14.5713 13.7142Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M21.4284 0.857178H2.57122C1.62445 0.857178 0.856934 1.62469 0.856934 2.57146V18.8572C0.856934 19.804 1.62445 20.5715 2.57122 20.5715H21.4284C22.3752 20.5715 23.1426 19.804 23.1426 18.8572V2.57146C23.1426 1.62469 22.3752 0.857178 21.4284 0.857178Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M14.5713 5.57141V7.71427"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M14.5713 13.7142V15.8571"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M19.7141 10.7142H17.5713"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M11.5716 10.7142H9.42871"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M18.2059 7.07996L16.6973 8.58853"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12.4456 12.84L10.937 14.3485"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M18.2059 14.3485L16.6973 12.84"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12.4456 8.58853L10.937 7.07996"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M5.14307 7.71423V13.7142"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M3.42871 20.5714V23.1428"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M19.7144 20.5714V23.1428"
        />
      </g>
    </svg>
  );
}
